import { axiosInstance } from "../axios";

export const menuApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/menu", { params });
  },
  create: async (body) => {
    return await axiosInstance.post("/menu", body);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/menu/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/menu/${id}`);
  },
  getById: async (id) => {
    return await axiosInstance.get(`/menu/getById/${id}`);
  },
  updateGoodsToMenu: async (id, body) => {
    return await axiosInstance.put(`/menu/updateGoods/${id}`, body);
  },
  getGoodsInMenu: async (id) => {
    return await axiosInstance.get(`/menu/getGoodsById/${id}`);
  },
  updateStatus: async (id, body) => {
    return await axiosInstance.put(`/menu/status/${id}`, body);
  },
};
